import tokenService from '../../service/TokenService';

export default {
    namespaced: true,
    state: {
        isAuthenticated: false,
        isAuthenticating: false,
        authError: null
    },
    mutations: {
        SET_IS_AUTHENTICATED(state, value) {
            state.isAuthenticated = value;
        },
        SET_IS_AUTHENTICATING(state, value) {
            state.isAuthenticating = value;
        },
        SET_AUTH_ERROR(state, error) {
            state.authError = error;
        }
    },
    actions: {
        async checkAuthStatus({ commit }) {
            commit('SET_IS_AUTHENTICATING', true);
            try {
                const token = await tokenService.getToken(["User.Read"]);
                commit('SET_IS_AUTHENTICATED', !!token);
                commit('SET_AUTH_ERROR', null);
            } catch (error) {
                console.error('Authentication check failed:', error);
                commit('SET_IS_AUTHENTICATED', false);
                commit('SET_AUTH_ERROR', error.message);
            } finally {
                commit('SET_IS_AUTHENTICATING', false);
            }
        },
        async login({ commit, dispatch }) {
            commit('SET_IS_AUTHENTICATING', true);
            try {
                const token = await tokenService.getToken(["User.Read"]);
                if (token) {
                    commit('SET_IS_AUTHENTICATED', true);
                    commit('SET_AUTH_ERROR', null);
                    return true;
                }
                throw new Error('Failed to obtain authentication token');
            } catch (error) {
                console.error('Login failed:', error);
                commit('SET_AUTH_ERROR', error.message);
                commit('SET_IS_AUTHENTICATED', false);
                return false;
            } finally {
                commit('SET_IS_AUTHENTICATING', false);
            }
        }
    },
    getters: {
        isAuthenticated: state => state.isAuthenticated,
        isAuthenticating: state => state.isAuthenticating,
        authError: state => state.authError
    }
};
